const initialState = {
    profile: {
        current_branch: {}
    },
    user_branches: [],
    profile_loaded: false
}

function profile(state = initialState, action) {
    switch (action.type) {

        case 'PROFILE_LOADED': {
            const { profile } = action
            const data = profile.data   
            if (data.success === true) {
                return { ...state, profile: data.user, user_branches: data.user_branches, profile_loaded: true }
            }
            
            return { ...state, profile: {}, user_branches: [], profile_loaded: false }
        }
        case 'LOGGED_OUT': {  
            return { ...state, profile: {}, user_branches: [], profile_loaded: false }
        }
        default:
            return state
    }
}

export default profile